import { useQuery } from '@tanstack/react-query';
import type { SystemInfo } from '@shared/types/system';

/** Сведения о сборке: один ключ кэша на подвал, сайдбар и окно «О системе». */
export function useSystemInfo() {
  return useQuery<SystemInfo>({
    queryKey: ['systemInfo'],
    queryFn: () => import('@shared/api/systemApi').then((m) => m.getSystemInfo()),
    staleTime: 5 * 60 * 1000,
  });
}
